<template>
  <div class="page__wrapper">
    <FCBackgroundVideo video="stadium-fins.mp4" />
    <img src="~@/assets/home-left-brush.png" alt class="home left" />
    <img src="~@/assets/home-right-brush.png" alt class="home right" />
    <img src="~@/assets/come-together.png" alt class="logo" />
    <Welcome v-if="$store.state.menu.showWelcome" />
  </div>
</template>

<script>
import FCBackgroundVideo from "@/components/patterns/FCBackgroundVideo";
import Welcome from "@/components/sections/Home/Welcome";
export default {
  name: "home",
  components: {
    FCBackgroundVideo,
    Welcome
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  padding-top: 0;
  overflow: hidden;
}
.home {
  position: absolute;
  top: 0;
}
.left {
  left: 0;
  height: 100%;
}
.right {
  right: 0;
}
.logo {
  position: absolute;
  top: 26px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 465px;
  width: calc(30vw);
}
@media (max-width: 1000px) {
  .right {
    display: none;
  }
}
</style>